import React, { useEffect, useState } from "react";
import { MenuFoldOutlined, MenuUnfoldOutlined } from "@ant-design/icons";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { Link } from "react-router-dom";
import { Outlet } from "react-router-dom";
import { Layout, Menu, theme } from "antd";
import { useNavigate } from "react-router-dom";
const { Header, Sider, Content } = Layout;
const MainLayout = () => {
  const [collapsed, setCollapsed] = useState(false);
  const {
    token: { colorBgContainer },
  } = theme.useToken();
  const navigate = useNavigate();
  const [user, setUser] = useState("");
  useEffect(() => {
    // Retrieve user details from local storage
    const userData = localStorage.getItem("user");

    if (userData) {
      setUser(JSON.parse(userData));
    }
  }, []);

  const handleSignout = () => {
    // Clear local storage
    localStorage.clear();
    // Redirect to the sign-in page or perform other sign-out actions
    // navigate('/signin');
  };
  return (
    <Layout /* onContextMenu={(e) => e.preventDefault()} */>
      <Sider trigger={null} collapsible collapsed={collapsed}>
        <div className="logo">
          <h2 className="text-white fs-5 text-center py-3 mb-0">
            <span className="sm-logo">TA</span>
            <span className="lg-logo">Two App</span>
          </h2>
        </div>
        <Menu
          theme="dark"
          mode="inline"
          defaultSelectedKeys={[""]}
          onClick={({ key }) => {
            if (key === "signout") {
            } else {
              navigate(key);
            }
          }}
          items={[
            {
              key: "",

              label: "Dashboard",
            },
            {
              key: "News Repoter",

              label: "News Repoter",
              children: [
                {
                  key: "Add-News-Repoter",

                  label: "Add-News Repoter",
                },
                {
                  key: "News-Repoter-list",

                  label: "News Repoter List",
                }
              ],
            },
            {
              key: "Association",

              label: "Association",
              children: [
                {
                  key: "Add-Association",

                  label: "Add-Association",
                },
                {
                  key: "Association-list",

                  label: "Association List",
                }
              ],
            },
            {
              key: "DMC",

              label: "DMC",
              children: [

                {
                  key: "DMC-list",

                  label: "DMC List",
                },
                {
                  key: "Tailor-Made",

                  label: "Tailor-Made",
                }
              ],
            },
            {
              key: "Asego-Booking",

              label: "Asego Booking",
              children: [
                {
                  key: "Asego-Booking-list",

                  label: "Asego Booking List",
                }
              ],
            },
            {
              key: "Villa-Booking",

              label: "Villa Booking",
              children: [
                {
                  key: "Villa-Booking-list",

                  label: "Villa Booking List",
                }
              ],
            },
            {
              key: "Interviews",

              label: "Interviews",
              children: [
                {
                  key: "Add-Interview",

                  label: "Add-Interview",
                },
                {
                  key: "Interview-list",

                  label: "Interview List",
                }
              ],
            },
            {
              key: "TvProgram",

              label: "TvProgram",
              children: [
                {
                  key: "Add-TvProgram",

                  label: "Add-TvProgram",
                },
                {
                  key: "TvProgram-list",

                  label: "TvProgram List",
                }
              ],
            },
            {
              key: "RadioProgram",

              label: "RadioProgram",
              children: [
                {
                  key: "Add-Radio-Program",

                  label: "Add Radio Program",
                },
                {
                  key: "Radio-Program-list",

                  label: "Radio Program List",
                }
              ],
            },
            {
              key: "FeaturedPackages",

              label: "Featured Packages",
              children: [
                {
                  key: "Featured-Packages-list",

                  label: "Featured Packages List",
                }
              ],
            },
            {
              key: "News",

              label: "News",
              children: [
                {
                  key: "Add-News",

                  label: "Add News",
                },
                {
                  key: "News-list",

                  label: "News List",
                },
                {
                  key: "News-category",

                  label: "Add News Category",
                },
                {
                  key: "News-category-list",

                  label: "News Category List",
                },
              ],
            },
            {
              key: "Luxury",

              label: "Luxury",
              children: [
                {
                  key: "Luxury-Hotel",

                  label: "Luxury Hotel",
                  children: [
                    {
                      key: "Add-Luxury-Hotel",

                      label: "Add Luxury Hotel",
                    },
                    {
                      key: "Luxury-Hotel-list",

                      label: "Luxury Hotel List",
                    },

                  ],
                },
                {
                  key: "Luxury-Transport",

                  label: "Luxury Transport",
                  children: [
                    {
                      key: "Add-Luxury-Transport",

                      label: "Add Luxury Transport",
                    },
                    {
                      key: "Luxury-Transport-list",

                      label: "Luxury Transport List",
                    },

                  ],
                },

              ],
            },
            {
              key: "Advisory-Board",

              label: "Advisory Board",
              children: [
                {
                  key: "Add-Advisory-Board",

                  label: "Add Advisory Board",
                },
                {
                  key: "Advisory-Board-list",

                  label: "Advisory Board List",
                },

              ],
            },
            {
              key: "Advertisement",

              label: "Advertisement",
              children: [
                {
                  key: "Add-Advertisement",

                  label: "Add Advertisement",
                },
                {
                  key: "Advertisement-list",

                  label: "Advertisement List",
                },

              ],
            },

            {
              key: "Two Campus",

              label: "Two Campus",
              children: [{
                key: "Destination",

                label: "Destination",
                children: [
                  {
                    key: "Country",

                    label: "Country",
                    children: [{
                      key: "Add-Country",

                      label: "Add Country",
                    }, {
                      key: "Country-List",

                      label: "Country List",
                    }
                    ]

                  },
                  {
                    key: "Country-Category",

                    label: "Country Category",
                    children: [{
                      key: "Add-Country-Category",

                      label: "Add Country Category",
                    }, {
                      key: "Country-Category-List",

                      label: "Country Category List",
                    }
                    ]

                  },
                  {
                    key: "Country-Data",

                    label: "Country Data",
                    children: [{
                      key: "Add-Country-Data ",

                      label: "Add Country Data",
                    }, {
                      key: "Country-Data-List",

                      label: "Country Data List",
                    }
                    ]

                  }

                ]
              }, {
                key: "Skill Development",

                label: "Skill Development",
                children: [{

                }]
              }


              ],
            },

            {
              key: "PPP",

              label: "PPP",
              children: [
                {
                  key: "Add-PPP",

                  label: "Add-PPP",
                },
                {
                  key: "PPP-list",

                  label: "PPP List",
                }
              ],
            },
            {
              key: "Live Event",

              label: "Live Event",
              children: [
                {
                  key: "All-Scedule-Live-Event",

                  label: "All Scedule Live Event",
                },
                {
                  key: "All-Past-Live-Event",

                  label: "All Past Live Event",
                }
              ],
            },
            {
              key: "Gallery-Image",

              label: "Gallery Imaget",
              children: [
                {
                  key: "Add-GalleryImage",

                  label: "Add Gallery Image",
                },
                {
                  key: "GalleryImage-list",

                  label: "Gallery Image list",
                }
              ],
            },
          ]}
        />
      </Sider>
      <Layout className="site-layout">
        <Header
          className="d-flex justify-content-between ps-1 pe-5"
          style={{
            padding: 0,
            background: colorBgContainer,
          }}
        >
          {React.createElement(
            collapsed ? MenuUnfoldOutlined : MenuFoldOutlined,
            {
              className: "trigger",
              onClick: () => setCollapsed(!collapsed),
            }
          )}
          <div className="d-flex gap-4 align-items-center">


            <div className="d-flex gap-3 align-items-center dropdown">
              <div>
                <img
                  width={32}
                  height={32}
                  src={user ? user.avatar : ""} // Use user's avatar if available
                  alt={user ? user.name : ""}
                />
              </div>
              <div
                role="button"
                id="dropdownMenuLink"
                data-bs-toggle="dropdown"
                aria-expanded="false"
              >
                <h5 className="mb-0">{user.name}</h5>
                <p className="mb-0">{user.email}</p>
              </div>
              <div className="dropdown-menu" aria-labelledby="dropdownMenuLink">
                <li>
                  <Link
                    className="dropdown-item py-1 mb-1"
                    style={{ height: "auto", lineHeight: "20px" }}
                    onClick={handleSignout}
                    to="/"
                  >
                    View Profile
                  </Link>
                </li>
                <li>
                  <Link
                    className="dropdown-item py-1 mb-1"
                    style={{ height: "auto", lineHeight: "20px" }}
                    to="/"
                    onClick={handleSignout}
                  >
                    Signout
                  </Link>
                </li>
              </div>
            </div>
          </div>
        </Header>
        <Content
          style={{
            margin: "24px 16px",
            padding: 24,
            minHeight: 280,
            background: colorBgContainer,
          }}
        >
          <ToastContainer
            position="top-right"
            autoClose={250}
            hideProgressBar={false}
            newestOnTop={true}
            closeOnClick
            rtl={false}
            pauseOnFocusLoss
            draggable
            theme="light"
          />
          <Outlet />
        </Content>
      </Layout>
    </Layout>
  );
};
export default MainLayout;
